import { render, staticRenderFns } from "./NewWidgetSkilledWorkerVisa.vue?vue&type=template&id=2fb033ca&scoped=true&lang=pug"
import script from "./NewWidgetSkilledWorkerVisa.vue?vue&type=script&lang=ts"
export * from "./NewWidgetSkilledWorkerVisa.vue?vue&type=script&lang=ts"
import style0 from "./NewWidgetSkilledWorkerVisa.vue?vue&type=style&index=0&id=2fb033ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb033ca",
  null
  
)

/* custom blocks */
import block0 from "./NewWidgetSkilledWorkerVisa.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FV2%2FWidgetSkilledWorkerVisa%2FNewWidgetSkilledWorkerVisa.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports